import plusIconBlack from "@/assets/img/plus-icon.svg";
import { PublishingState } from "@/generated/types";
import PlusIcon from "@/icons/Plus.icon";
import ProjectPublished from "@/icons/ProjectPublished.icon";
import ProjectUnpublished from "@/icons/ProjectUnpublished.icon";
import { BCard, BContainer, BSpinner } from "@/lib/typed-bootstrap";
import { getOrgApis, IOrgApiState } from "@/models/org";
import { OrgModule } from "@/store";
import { Component, Vue, Watch } from "vue-property-decorator";
import * as tsx from "vue-tsx-support";
import styles from "./OrgApiDashboard.view.module.scss";

@Component({})
export default class Dashboard extends Vue {
  _tsx!: tsx.DeclareProps<{}> & tsx.DeclareOnEvents<{}>;

  apis: IOrgApiState[] = [];
  isLoading = false;

  plusIconSrc = plusIconBlack;

  get orgId() {
    return OrgModule.id;
  }

  get workspaceName() {
    return OrgModule.name ?? "Your Workspace";
  }

  @Watch("orgId", { immediate: true })
  async onOrgChange() {
    if (!OrgModule.id) return;
    this.isLoading = true;
    try {
      this.apis = await getOrgApis(OrgModule.id);
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  }

  getApiStateClass(state: string | null | undefined): string {
    switch (state) {
      case "INITIALIZED":
        return "init";
      case "PUBLISHING_FAILED":
        return "failed";
      case "PUBLISHED":
        return "live";
      default:
        return "";
    }
  }

  projectIsPublished(state: string | null | undefined) {
    return (
      state !== PublishingState.INITIALIZED &&
      state !== PublishingState.IMPORTED
    );
  }

  render() {
    return (
      <BContainer class="default__view-setup">
        <div class="default__section-header">
          {this.$t("org_api_dashboard_title")}
        </div>
        <div class="default__section-subheader">
          {this.$t("org_api_dashboard_subtitle")}
        </div>
        {this.isLoading ? (
          <div class="d-flex default__spinner" role="status">
            <BSpinner type="grow" label="Loading..." variant="light" />
          </div>
        ) : (
          <div style={{ marginTop: "40px" }}>
            <div class="row">
              <div class="col-12 col-sm-6 col-md-4 col-lg-3 p-3 grow">
                <BCard
                  bodyClass={styles.cardBody}
                  class={styles.newProjectCard}
                >
                  <router-link
                    class={styles.widgetButton}
                    to={{ name: "project-setup-name" }}
                    data-testid="create-api"
                  >
                    <div class={styles.widgetBody}>
                      <div class={styles.newProjectHeader}>
                        <div class={styles.publishingStatus}>
                          <div>&nbsp;</div>
                        </div>
                        <div class={styles.projectLogo}>
                          <PlusIcon />
                        </div>
                      </div>
                      <div class={styles.projectDetails}>
                        <div class={styles.newProjectCta}>
                          {this.$t("org_api_dashboard_cta")}
                        </div>
                      </div>
                    </div>
                  </router-link>
                </BCard>
              </div>
              {this.apis.map((api) => (
                <BCard
                  key={api.id}
                  bodyClass={styles.cardBody}
                  class="col-12 col-sm-6 col-md-4 col-lg-3 p-3 grow"
                >
                  <router-link
                    class={styles.widgetButton}
                    to={{ name: "project-overview", params: { apiId: api.id } }}
                  >
                    <div class={styles.widgetBody}>
                      <div class={styles.projectWidgetHeader}>
                        <div class={styles.publishingStatus}>
                          {this.projectIsPublished(api.state) && (
                            <div class={styles.liveDot}></div>
                          )}
                          <div
                            class={[this.getApiStateClass(api.state)].join(" ")}
                          >
                            {this.$t(`api_status.${api.state}`).toString()}
                          </div>
                        </div>
                        <div class={styles.projectLogo}>
                          {this.projectIsPublished(api.state) ? (
                            <ProjectPublished />
                          ) : (
                            <ProjectUnpublished />
                          )}
                        </div>
                      </div>
                      <div class={styles.projectDetails}>
                        <div class={styles.projectName}>{api.name}</div>
                        <div class={styles.projectRegion}>
                          {this.$t(`aws_region.${api.region}`).toString()}
                        </div>
                      </div>
                    </div>
                  </router-link>
                </BCard>
              ))}
            </div>
          </div>
        )}
      </BContainer>
    );
  }
}
